import api from '../callApi';
import humanparser from 'humanparser';

const completePetition = (
    apiRequestData,
    actionCompletedTime,
    values,
    localRepData,
    useLocalRepresentative
) => {
    const name = humanparser.parseName(values.fullName);
    let representatives = [];
    let address = {};

    if (useLocalRepresentative) {
        representatives = [
            {
                level: localRepData.representative[0].level,
                name: localRepData.representative[0].fullName,
                state: localRepData.state,
                districtNo: localRepData.district
            }
        ];

        address = {
            ...localRepData.address,
            source: localRepData.isUserInput ? 0 : 1
            // source: 0 = user input
        };
    }

    const request = {
        ...apiRequestData,
        actionCompletedTime: actionCompletedTime,

        email: values.email,
        zipCode: values.postalCode,
        country:
            localRepData.representative !== undefined
                ? localRepData.representative[0].fullName !== undefined
                    ? localRepData.address.country
                    : 'N/A'
                : 'N/A',
        from: values.petition,
        firstName: name.middleName
            ? name.firstName + ' ' + name.middleName
            : name.firstName,
        lastName: name.lastName,
        prefix: values.prefix,
        text: values.message,
        notifyResult: values.getUpdates,

        representatives: representatives,

        address: address
    };

    return api.post('Widget/CompletePetitionAsync', request).then(response => {
        return response;
    });
};

export default completePetition;



// WEBPACK FOOTER //
// ./src/utils/petition/petitionApi.js